import { render, staticRenderFns } from "./isNeedSmtReviewFileDialog.vue?vue&type=template&id=db04a81e&scoped=true"
import script from "./isNeedSmtReviewFileDialog.vue?vue&type=script&lang=js"
export * from "./isNeedSmtReviewFileDialog.vue?vue&type=script&lang=js"
import style0 from "./isNeedSmtReviewFileDialog.vue?vue&type=style&index=0&id=db04a81e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db04a81e",
  null
  
)

export default component.exports